<template>
  <category-menu-group-orders :company="company" />
</template>

<script>
import CategoryMenuGroupOrders from "@/components/categoryMenuGroup/CategoryMenuGroupOrders.vue";

export default {
  components: {
    CategoryMenuGroupOrders,
  },
  computed: {
    company() {
      return this.$store.state.company;
    },
  },
};
</script>
